/*
 * File: GuarantorsLinks.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays and styles links to primary and secondary guarantor in a list. If secondary guarantor doesn't exist, shows "No Secondary Guarantor"
 */
import React from "react";
import PatientIdStore from "services/patients/store/PatientIdStore";
import { Toolbar, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import PatientChart from "../../topofthechart/PatientChart";
import UILinkList from "components/ui/UILinkList";
import MainHeader from "components/MainHeader";

const styles = theme => ({
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    marginBottom: theme.spacing(-2.5),
    marginTop: theme.spacing(2.5)
  },
  noData: {
    color: theme.palette.common.subtitle,
    fontStyle: "italic"
  }
});

const GuarantorsLinks = ({ primaryGuarantor, secondaryGuarantor, classes }) => {
  const linkTo = guarantorType => {
    const patientId = PatientIdStore.getId();
    return (
      "/patients/" +
      patientId +
      "/insurance_and_guarantors/guarantors/" +
      guarantorType
    );
  };

  const formatGuarantorName = guarantor => {
    const middle = guarantor.middleName ? " " + guarantor.middleName : "";
    return guarantor.lastName + ", " + guarantor.firstName + middle;
  };

  const formatNoData = () => {
    return (
      <Typography className={classes.noData}>No Secondary Guarantor</Typography>
    );
  };
  const primaryDisplay = () => {
    return {
      primaryString: formatGuarantorName(primaryGuarantor),
      secondaryString: "Primary Guarantor",
      url: linkTo("primary")
    };
  };

  const secondaryDisplay = () => {
    if (secondaryGuarantor) {
      return {
        primaryString: formatGuarantorName(secondaryGuarantor),
        secondaryString: "Secondary Guarantor",
        url: linkTo("secondary")
      };
    } else {
      return {
        primaryString: formatNoData()
      };
    }
  };

  const links = [primaryDisplay(), secondaryDisplay()];

  return (
    <React.Fragment>
      <PatientChart />
      <Toolbar className={classes.toolbar}>
        <MainHeader
          pageTitle="Guarantors"
          pageSubtitle="Insurance & Guarantors"
        />
      </Toolbar>
      <UILinkList links={links} />
    </React.Fragment>
  );
};

GuarantorsLinks.propTypes = {
  primaryGuarantor: PropTypes.object.isRequired,
  secondaryGuarantor: PropTypes.object,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(GuarantorsLinks);
